import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('vendor_dashboard');
        localStorage.removeItem('vendor_dashboard_name');
        localStorage.removeItem('vendor_dashboard_email');
        localStorage.removeItem('vendor_dashboard_image');
        localStorage.removeItem('vendor_dashboard_status');
        navigate('/login')
    }, [navigate]);
    return null;
}

export default Logout;